import type { App } from "vue";

export interface Plugin {
  install(app: App): void;
}

import errorTracking from "./errorTracking";
import gettext from "./gettext";
import floatingVue from "./floating-vue";
import motion from "./motion";
import directiveLoading from "./directive-loading";
import directiveErrorShake from "./directive-error-shake";
import directiveAnimatePop from "./directive-animate-pop";

export const plugins: Plugin[] = [errorTracking, gettext, floatingVue, motion, directiveLoading, directiveErrorShake, directiveAnimatePop];
